/* eslint-disable func-names */
import Swipe from 'swipejs';

(function ($) {
    Electro.Home = (function () {
        return {
            onTransitionEnd(index) {
                $('#swipe-paw-nav ul li').each(function () {
                    $(this).html('<img alt="" src="/wp-content/themes/electro/img/home/slides/pawUnselected.jpg" />');
                });
                $('#swipe-paw-nav ul li')
                    .eq(index)
                    .html('<img alt="" src="/wp-content/themes/electro/img/home/slides/pawSelected.jpg" />');
            },

            slideToPosition(index) {
                Electro.Home.mySwipe.slide(index, 1000);
            },
        };
    })();

    $(document).ready(() => {
        [Electro.Home.elem] = $('#slideshowContainer');
        Electro.Home.mySwipe = Swipe(Electro.Home.elem, {
            // startSlide: 3,
            auto: 5000,
            continuous: true,
            disableScroll: true,
            stopPropagation: false,
            speed: 1000,
            transitionEnd: Electro.Home.onTransitionEnd,
        });

        $('#swipe-paw-nav ul > li').css('cursor', 'pointer');
        $('#swipe-paw-nav ul > li').click(function () {
            Electro.Home.slideToPosition($(this).index());
            return false;
        });
    });
})(jQuery);
